import React, { useEffect, useState } from 'react';
import translateText from './translateText';
import Cookies from 'js-cookie';  // Importe a biblioteca js-cookie
import { useParams} from 'react-router-dom';
import { useNavigate,Link } from "react-router-dom";
import Slider from 'react-slick';
import '../layout/RecentProds.Module.css'
import '../layout/ProdDetail.Module.css'
import {addToRecentView } from './ProdDetail'
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'
import { useAuth } from './AuthContext'
import { useLanguage } from './LanguageContext';
import ProductCard from './ProductCard';
import axios from 'axios'

function RecentProds({ items }) {
  const { t, i18n } = useTranslation('');
  const { user, toggleFavorite } = useAuth()
  const [product, setProduct] = useState(null);
  const [recentProducts, setRecentProducts] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const { selectedLanguage } = useLanguage();
  const [translatedNames, setTranslatedNames] = useState({});
  const [translatedProducts, setTranslatedProducts] = useState([]);

  // Função para carregar os produtos mais visualizados
  const loadRecentProducts = () => {
    const recentViews = Cookies.get('recentViews');
    if (recentViews) {
      let productIds = JSON.parse(recentViews);
  
      // Busca produtos
      fetch('https://backend-theta-gold-17.vercel.app/produtos')
        .then(response => response.json())
        .then(data => {
          const recentProducts = productIds
            .map(id => data.find(product => String(product.idP) === id))
            .filter(Boolean); // Remove produtos não encontrados
          setRecentProducts(recentProducts);
        })
        .catch(error => {
          console.error('Erro ao buscar produtos:', error);
        });
    }
  };

  useEffect(() => {
    loadRecentProducts();
  }, [Cookies.get('recentViews')]); // Recarrega quando os cookies mudam

    const twoFunctions =(nome,id)=>{
      addToRecentView(id)
      GotToNewPage(nome,id)
    }

  const GotToNewPage =(nome,id)=>{
    if (typeof nome !== 'string' || !nome.trim()) {
      console.error("Erro: 'nome' está indefinido ou não é uma string válida:", nome);
      return;
    }
    navigate(`/prodetail/${encodeURIComponent(nome.replace(/\s+/g, '-').toLowerCase())}/${id}`);
  }

  var recent = {
    autoplay: true,
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll:1,
    initialSlide: 0,
    speed: 1000,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
          infinite: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: false,
        }
      }
    ]
  };

  const [quickViewProduct, setQuickViewProduct] = useState(null);
  const [showQuickView, setShowQuickView] = useState(false);

  const handleQuickView = (product) => {
    setQuickViewProduct(product);
    setShowQuickView(true);
  };

  const closeQuickView = () => {
    setShowQuickView(false);
    setQuickViewProduct(null);
  };
  
  return (
    <>
    <div className="recomented-prods">
    
      {/* Exibe o título somente se houver produtos */}
      {recentProducts.length > 0 && (
        <h5 className='prod-info-title'>{t('pdetail.titlerecent')}</h5>
      )}
      
      <div className="recent-products-list">
      <div className="row mb-5">
        {recentProducts.length > 0 ? (  // Verificando se há produtos
          recentProducts.length > 5 ? (  // Verificando se há mais de 5 produtos
            <div className="slider-container mt-2">
            <Slider {...recent}>
              {recentProducts.map((resu, index) => (
                  <div className="col-sm-6 col-lg-3 col-md-3 col-6 product-card" key={index}>
                    <ProductCard resu={resu} toggleFavorite={toggleFavorite} addToRecentView={addToRecentView} t={t} />
                  </div>
              ))}
            </Slider>
            
            </div>
          ) : (
            // Caso tenha 5 ou menos produtos, exibe-os normalmente
            recentProducts.map((resu, index) => (
              <div className="col-4 col-md-3 col-xl-2" key={index}>
                  <ProductCard resu={resu} toggleFavorite={toggleFavorite} addToRecentView={addToRecentView} t={t} />
              </div>
            ))
          )
        ) : (
          <></>  // Caso não haja produtos
        )}
      </div>
    </div>
    </div>
    </>
  )
}

export default RecentProds